export default __webpack_public_path__ + "static/media/02.09.030.38a2780d.png";